// extracted by mini-css-extract-plugin
export default {"button_onlyIcon":"LG4UX","button_view_tertiary-invert":"wslBw","button_view_tertiary":"WhsVz"};